import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import Header from '../../components/landing/Header';
import Footer from '../../components/landing/Footer';

const groups = [
  {
    label: 'Bookings',
    items: [
      {
        q: 'Do I need to book in advance?',
        a: 'For boarding and resort stays — yes. Slots fill quickly around holidays. Day care and walks can usually be arranged with a day\'s notice.',
      },
      {
        q: 'How do I confirm a booking?',
        a: 'Bookings are confirmed once payment is received and capacity is available. We always confirm in writing — email or message.',
      },
      {
        q: 'What\'s your cancellation policy?',
        a: 'Full refund if you cancel 48+ hours before. 50% within 48 hours. No-shows aren\'t refundable.',
      },
    ],
  },
  {
    label: 'At our facilities',
    items: [
      {
        q: 'Where is PetCart Nest located?',
        a: 'Survey No 136/18, V Kallhalli, Sarjapura Main Road, Anekal TQ, Bangalore 562125.',
      },
      {
        q: 'Are pets supervised through the day?',
        a: 'Yes — trained staff are on-site through the day, and swim sessions are always supervised.',
      },
      {
        q: 'Do you require vaccinations?',
        a: 'Yes. Pets must be up to date on core vaccinations before any stay or day-care session.',
      },
    ],
  },
  {
    label: 'Getting in touch',
    items: [
      {
        q: 'How do I reach you?',
        a: 'Email shekhar@petcart.com or use the phone number in the footer. We respond within a working day.',
      },
      {
        q: 'Can I visit before I book?',
        a: 'Absolutely — we love that. Drop us a line and we\'ll set up a walk-through.',
      },
    ],
  },
];

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-neutral-200 last:border-0">
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between gap-6 py-5 text-left"
      >
        <span className="text-base font-medium text-neutral-900">{q}</span>
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-neutral-200 text-neutral-600">
          {open ? <Minus size={14} /> : <Plus size={14} />}
        </span>
      </button>
      {open && <p className="pb-5 pr-12 text-[15px] leading-7 text-neutral-600">{a}</p>}
    </div>
  );
};

const Faqs = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <section className="bg-white pt-40 pb-10 sm:pt-48 sm:pb-12">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">FAQs</p>
        <h1 className="mt-3 text-4xl font-semibold leading-tight tracking-tight text-neutral-900 sm:text-5xl">
          Things people ask us.
        </h1>
        <p className="mt-4 text-base text-neutral-600 sm:text-lg">
          If your question isn't here, write to{' '}
          <a href="mailto:shekhar@petcart.com" className="font-medium text-primary hover:underline">
            shekhar@petcart.com
          </a>
          .
        </p>
      </div>
    </section>

    <section className="bg-white pb-20">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        {groups.map((g) => (
          <div key={g.label} className="mt-10 first:mt-0">
            <p className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-neutral-500">
              {g.label}
            </p>
            <div>
              {g.items.map((item) => (
                <FaqItem key={item.q} {...item} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>

    <Footer />
  </div>
);

export default Faqs;
